"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLanguageTypeToSupportPageLocale = mapLanguageTypeToSupportPageLocale;
const Translations_1 = require("./cms/Translations");
const LANGUAGE_TYPE_TO_SUPPORT_PAGE_LOCALE = {
    [Translations_1.LanguageType.English]: 'en',
    [Translations_1.LanguageType.PortugueseBrazil]: 'pt',
    [Translations_1.LanguageType.Spanish]: 'es',
};
function mapLanguageTypeToSupportPageLocale(languageType) {
    if (languageType in LANGUAGE_TYPE_TO_SUPPORT_PAGE_LOCALE) {
        return LANGUAGE_TYPE_TO_SUPPORT_PAGE_LOCALE[languageType];
    }
    return 'en';
}
